import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  animatedViewContainer: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
  },
  bottomBlock: { height: 20 },
  container: { padding: 10 },
  contentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: 10,
    width: "100%",
  },
  contentDateText: {
    color: colors.placeholder,
    fontFamily: typography.primary.normal,
    fontSize: 13,
    marginTop: 5,
  },
  expiredDateText: {
    color: colors.primary,
    fontFamily: typography.primary.normal,
    fontSize: 13,
    marginTop: 5,
    borderRadius: 8,
  },
  emptyContainer: {
    alignItems: "center",
    flex: 1,
    height: "100%",
    justifyContent: "center",
  },
  emptyTitleText: {
    marginTop: 20,
    fontFamily: typography.primary.normal,
    fontSize: 25,
    padding: 20,
  },
  flex: { flex: 1 },
  greenText: { color: colors.green },
  headerBottomPointContainer: { alignItems: "center" },
  headerBottomPointText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 24,
    marginTop: 10,
  },
  headerBottomTitleText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 18,
    marginTop: -20,
  },
  headerContainer: {
    alignItems: "center",
    height: 40,
  },
  headerContentContainer: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 10,
    width: "100%",
  },
  headerIconContainer: { alignSelf: "flex-start" },
  headerTopPointText: { color: colors.white, fontFamily: typography.primary.normal, fontSize: 17 },
  linearGradient: {
    borderBottomEndRadius: 20,
    borderBottomLeftRadius: 20,
    overflow: "hidden",
    paddingTop: 20,
    position: "absolute",
  },
  pointContentText: { fontFamily: typography.primary.normal },
  pointContentTitle: { fontFamily: typography.primary.normal, fontSize: 20, marginTop: 20 },
  redText: { color: colors.error },
  separator: { backgroundColor: colors.placeholder, height: 0.5 },
})
